// extracted by mini-css-extract-plugin
module.exports = {"forbidden":"_403_forbidden_17XhR","code":"_403_code_d3QU7","tipText":"_403_tipText_1_9XT"};